import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgStandleiding = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="m20 6 12 9.33V34H8V15.33z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M10 29.5c0-1.38 2.5-5 2.5-5s2.5 3.62 2.5 5a2.5 2.5 0 0 1-5 0M22.57 23h-5.14a.43.43 0 0 0-.43.43v1.14c0 .238.192.43.43.43h5.14a.43.43 0 0 0 .43-.43v-1.14a.43.43 0 0 0-.43-.43M28.57 31h-5.14a.43.43 0 0 0-.43.43v1.14c0 .237.192.43.43.43h5.14a.43.43 0 0 0 .43-.43v-1.14a.43.43 0 0 0-.43-.43"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M18 28v-8h4v6h4a2 2 0 0 1 2 2v7h-4v-5h-4a2 2 0 0 1-2-2"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M29.63 20.5H10v-1h19.63z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgStandleiding);

export default ForwardRef;
